import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function ImageSlider({ images }) {
  let sliderRef = useRef(null);
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  };
  return (
    <div className="slider-container overflow-hidde text-center">
      <Slider ref={slider => (sliderRef = slider)} {...settings}>
        {images?.map((image) => (
          <div className="sm:h-[400px] h-[300px]" key={image.id}>
            <img className="w-full h-full object-cover object-center" src={image.source} alt={image.description} />
          </div>
        ))}
      </Slider>
    </div>
  );
}
export default ImageSlider;